import { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Chip, Divider, Typography, useMediaQuery } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import menuItem from '../../../Menu';
import { DashboardMenu } from '../../../Menu/dashboard';

import { useSelector } from 'layout/mantis/store';
import useConfigContext from 'context/useConfigContext';
import useAuthContext from 'context/useAuthContext';
import { HORIZONTAL_MAX_ITEM } from 'Config';

// types
import { NavItemType } from 'layout/mantis/types/MenuType';
import { LAYOUT_CONST } from 'types/ConfigType';
import NavItem from './NavItem';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
	const theme = useTheme();

	const downLG = useMediaQuery(theme.breakpoints.down('lg'));

	const { menuOrientation } = useConfigContext();
	const { items: menu_items } = menuItem();

	const { drawerOpen } = useSelector((state) => state.menu);
	const [selectedItems, setSelectedItems] = useState<string | undefined>('');
	const [selectedLevel, setSelectedLevel] = useState<number>(0);

	useEffect(() => {
		handlerMenuItem();
		// eslint-disable-next-line
	}, []);

	let getDash = DashboardMenu();

	const handlerMenuItem = () => {
		const isFound = menu_items.some((element) => {
			if (element.id === 'group-dashboard') {
				return true;
			}
			return false;
		});

		if (getDash?.id !== undefined && !isFound) {
			menu_items.splice(0, 0, getDash);
		}
	};

	const isHorizontal = menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;

	const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
	let lastItemIndex = menu_items.length - 1;
	let remItems: NavItemType[] = [];
	let lastItemId: string;

	if (lastItem && lastItem < menu_items.length) {
		lastItemId = menu_items[lastItem - 1].id!;
		lastItemIndex = lastItem - 1;
		remItems = menu_items.slice(lastItem - 1, menu_items.length).map((item) => ({
			title: item.title,
			elements: item.children,
			icon: item.icon
		}));
	}

	const navGroups = menu_items.slice(0, lastItemIndex + 1).map((item) => {
		switch (item.type) {
			case 'group':
				return (
					<NavGroup
						key={item.id}
						setSelectedItems={setSelectedItems}
						setSelectedLevel={setSelectedLevel}
						selectedLevel={selectedLevel}
						selectedItems={selectedItems}
						lastItem={lastItem!}
						remItems={remItems}
						lastItemId={lastItemId}
						item={item}
					/>
				);
			case 'item':
				return <NavItem key={item.id} item={item} level={0} />;
			default:
				return (
					<>
						{/*<Typography key={ item.id } variant='h6' color='error' align='center'>
							Fix - Navigation Group
						</Typography>*/}
					</>
				);
		}
	});
	return (
		<Box
			sx={{
				pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
				'& > ul:first-of-type': { mt: 0 },
				display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block'
			}}
		>
			{navGroups}
		</Box>
	);
};

export default Navigation;
